/**
 * Reading a treatment description the way the studio writes them.
 *
 * Descriptions on the live menu open with a short line naming the kind of
 * treatment - "Personalised Skincare", "Sculpting and Lymphatic Facial" - then a
 * blank line, then the paragraphs. The homepage sets that first line in small
 * capitals above the treatment's name rather than as the first sentence of its
 * description.
 *
 * It is recognised by shape rather than marked up, so descriptions written
 * before this existed work unchanged: a first paragraph that is one short line
 * with no closing punctuation is a subtitle; anything else is prose, and the
 * whole description is the body.
 */
const SUBTITLE_MAX_CHARS = 60;

export interface DescriptionParts {
  subtitle: string | null;
  body: string;
}

export function splitDescription(description: string | null): DescriptionParts {
  const text = (description ?? '').trim();
  const [first = '', ...rest] = text.split(/\n\s*\n/);
  const candidate = first.trim();

  const isSubtitle =
    rest.length > 0 &&
    !candidate.includes('\n') &&
    candidate.length <= SUBTITLE_MAX_CHARS &&
    !/[.!?:;,]$/.test(candidate);

  if (!isSubtitle) return { subtitle: null, body: text };
  return { subtitle: candidate, body: rest.join('\n\n').trim() };
}
